import styled from 'styled-components';
import { Card as CommonCard } from 'components/common/Card/Card';

export const TablesWrapper = styled.div`
  margin-top: 1.875rem;
`;

export const Card = styled(CommonCard)`
  margin-bottom: 2rem;
`;
